import React, { useContext, useEffect, useState } from "react";

import FormRadio from "../FastReservation/FormRadio";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";
import { useField } from "formik";
import { StoreContext } from "../../context/context";
import { useTranslation } from "../../context/TranslationContext";

const FirstPayment = ({ reservationResult, payment_type }) => {
  const { depositPrice, reservationPaymentAll } = useTranslation();
  const { page } = useContext(StoreContext);
  const [field, meta, helpers] = useField("firstPayment");

  const initialValue = payment_type == "all" ? 2 : 1;
  const [paymentType, setpaymentType] = useState(initialValue);

  useEffect(() => {
    helpers.setValue(paymentType);
  }, [paymentType]);

  const width = payment_type == 'default' ? 'w-1/2' : 'w-full';

  return (
    <div className="flex border-b-2 border-['#EFF5F7'] flex-col sm:flex-row">
      {reservationResult.success && (
        <>
          {payment_type !== "all" && (
            <FormRadio
              name={"payment"}
              value="1"
              width={width}
              text={depositPrice + " (%" + page.Product.depozito + ")"}
              paymentType={paymentType}
              setpaymentType={setpaymentType}
              content={
                <DefaultCurrencyFormat
                  value={reservationResult.result.deposit_price}
                  Symbol={reservationResult.result.symbol}
                ></DefaultCurrencyFormat>
              }
            ></FormRadio>
          )}
          {payment_type !== "advance" && (
            <FormRadio
              name={"payment"}
              value="2"
              width={width}
              text={reservationPaymentAll}
              paymentType={paymentType}
              setpaymentType={setpaymentType}
              content={
                <DefaultCurrencyFormat
                  value={reservationResult.result.accommodation_fee}
                  Symbol={reservationResult.result.symbol}
                ></DefaultCurrencyFormat>
              }
            ></FormRadio>
          )}
        </>
      )}
    </div>
  );
};

export default FirstPayment;
